import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const autoRequestFields = [
  "gaming_autorequestid", // UID
  "gaming_topictype", // Choice
  "gaming_AutoRequestTopic", // Lookup
  "gaming_requestorname", // Text
  "gaming_requestoremail", // Text
  "gaming_communicationemail", // Text
  "gaming_sellerid", // Text
  "gaming_selleridcompanyname", // Text
  "gaming_GameDeveloperPublisherAccount", // Lookup
  "gaming_emailsentdate", // Date
] as const;

export const autoRequestReferences: EntityReferences<EntityName.gaming_autorequest> = {
  [EntityName.account]: ["gaming_GameDeveloperPublisherAccount"],
  [EntityName.gaming_autorequesttopic]: ["gaming_AutoRequestTopic"],
};

export const autoRequestKey: AnyEntityField<EntityName.gaming_autorequest> = "gaming_autorequestid";
